import { useCurrentOrganisation } from 'Hooks/useCurrentOrganisation'
import { isAppWebsite } from 'Utils/helpers'
import { Breadcrumb } from 'antd'
import React from 'react'
import { useNavigate } from 'react-router'

interface BreadcrumbProps {
  defaultItems?: string[]
  itemList: any[]
}

const NavigationBreadCrumb: React.FC<BreadcrumbProps> = ({ defaultItems, itemList }) => {
  const { organisation } = useCurrentOrganisation()
  const navigate = useNavigate()

  function handleNav(e: React.MouseEvent, path: string) {
    e.preventDefault()
    navigate(path)
  }

  return (
    <Breadcrumb
      style={{
        width: 'max-content',
      }}
      separator="/"
    >
      <Breadcrumb.Item onClick={(e) => handleNav(e, '/')} href="">
        Clients
      </Breadcrumb.Item>
      {organisation && (
        <Breadcrumb.Item
          onClick={(e) => handleNav(e, `/clients/${organisation?.uuid}/voice-agents`)}
          href=""
        >
          {organisation?.display_name}
        </Breadcrumb.Item>
      )}
      {itemList}
    </Breadcrumb>
  )
}

export default NavigationBreadCrumb
